@if (isEligibleHabilitation) {
  <oui-slide-toggle label="Mise en place du réinvestissement des dividendes" [control]="rdControl"></oui-slide-toggle>
}
